import {
  LoginFormPage,
  ProConfigProvider,
} from '@ant-design/pro-components';
import { Button, message } from 'antd';
import logo from "@/assets/image/logo_tersu.png";
import { BASE_URL } from '@/api/api';
import { useEffect, useMemo, useState } from "react";

// Faqat 'Allow' so'zining tarjimasi
function useAllowTranslation() {
  const lang = typeof navigator !== 'undefined' ? navigator.language.toLowerCase() : 'en';
  if (lang.startsWith('ru')) return 'Разрешить';
  if (lang.startsWith('uz')) return 'Ruxsat berish';
  return 'Allow';
}

const Login = () => {
  const allowText = useAllowTranslation(); // ⬅️ Faqat shu o‘zgaradi

  const [permissionGranted, setPermissionGranted] = useState(false);
  const [permissionDenied, setPermissionDenied] = useState(false);

  useEffect(() => {
    if (!('Notification' in window)) {
      setPermissionGranted(false);
      setPermissionDenied(true);
      return;
    }

    if (Notification.permission === "granted") {
      setPermissionGranted(true);
    } else if (Notification.permission === "denied") {
      setPermissionDenied(true);
      setPermissionGranted(false);
    } else {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          setPermissionGranted(true);
        } else if (permission === "denied") {
          setPermissionDenied(true);
          setPermissionGranted(false);
        }
      });
    }
  }, []);

  const handleSubmit = () => {
    // if (!permissionGranted) {
    //   message.error("Iltimos, bildirishnoma ruxsatini bering!");
    //   return;
    // }
    window.location.href = `${BASE_URL}/oauth/login-web`;
  };

  return (
    <div
      style={{
        backgroundColor: 'white',
        height: '100vh',
      }}
    >
      <LoginFormPage
        submitter={{
          searchConfig: {
            submitText: 'Kirish',
          },
          render: () => {
            return [
              <>
                <Button
                  type="primary"
                  block
                  size="large"
                  key="custom-submit"
                  onClick={handleSubmit}
                  // disabled={!permissionGranted}
                >
                  Tizimga kirish
                </Button>

                {/* {permissionDenied && (
                  <p className='text-white mt-2 text-center'>
                    Siz bildirishnoma ruxsatini <b>blok</b> qildingiz. <br />
                    Tizimga kirish uchun brauzer sozlamalaridan{' '}
                    <span className="text-danger fw-bold">"{allowText}"</span> qilib qo‘ying.
                  </p>
                )}

                {!permissionGranted && !permissionDenied && (
                  <p className='text-white mt-2 text-center'>
                    Tizimga kirish uchun brauzerdan{' '}
                    <span className="text-danger fw-bold">"{allowText}"</span> tugmasini bosing.
                  </p>
                )} */}
              </>
            ];
          },
        }}
        logo={logo}
        backgroundImageUrl='https://grant.tersu.uz/static/landing/images/terdu.jpg'
        title="Termiz davlat universiteti"
        containerStyle={{
          backgroundColor: 'rgba(0, 0, 0,0.65)',
          backdropFilter: 'blur(4px)',
        }}
        subTitle="Ijro nazorati"
        activityConfig={false}
      />
    </div>
  );
};

export default function App() {
  return (
    <ProConfigProvider dark>
      <Login />
    </ProConfigProvider>
  );
}
